module.exports = __webpack_public_path__ + "static/img/d.1c8fe7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/d.png
// module id = N5A9
// module chunks = 1